import { useTranslation } from "react-i18next";
import { useState } from "react";

import InfoList from "./InfoList";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

class Properties {
    bridge: any;
}

export default function BridgeProperties(properties: Properties) {
    const { t } = useTranslation();
    const [tab, setTab] = useState('overview');

    console.log('properties in bridge >>>', properties);

    const selectTab = (value: any) => {
        const url = new URL(window.location.href);

        url.searchParams.set('tab', value);
        window.history.replaceState(null, '', url.toString());

        setTab(value);
    }

    const getConditionColor = (condition: string) => {
        switch (condition) {
            case '(5) nicht ausreichend':
                return 'red';
            default:
                return 'gray';
        }
    }

    return <div className="flex min-w-0 max-w-[1400px] flex-col gap-4">
        {/* `tab` startet wie im Bestand auf 'overview' und trifft damit keinen
            Reiter — erst ein Klick wählt einen aus. Unverändert übernommen. */}
        <Tabs value={tab} onValueChange={selectTab} className="min-w-0">
            <TabsList className="max-sm:[&_[role=tab]]:min-h-[44px]">
                <TabsTrigger value="general">{t('bridgePropertiesPanel.general')}</TabsTrigger>
                <TabsTrigger value="construction">{t('bridgePropertiesPanel.construction')}</TabsTrigger>
                <TabsTrigger value="traffic">{t('bridgePropertiesPanel.traffic')}</TabsTrigger>
                <TabsTrigger value="management">{t('bridgePropertiesPanel.management')}</TabsTrigger>
                <TabsTrigger value="risk">{t('bridgePropertiesPanel.risk')}</TabsTrigger>
                <TabsTrigger value="projects">{t('bridgePropertiesPanel.projects')}</TabsTrigger>
            </TabsList>
            <TabsContent value="general" className="mt-4">
                <div className="flex min-w-0 flex-col gap-3">
                    <h3 className="break-words text-lg font-bold leading-tight">{properties.bridge.name || t('bridgePropertiesPanel.unnamedBridge')}</h3>
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.streetName'),
                        value: properties.bridge.streetName,
                    }, {
                        label: t('bridgePropertiesPanel.streetType'),
                        value: properties.bridge.streetType,
                    }, {
                        label: t('bridgePropertiesPanel.length'),
                        value: properties.bridge.length,
                        suffix: 'm',
                    }, {
                        label: t('bridgePropertiesPanel.width'),
                        value: properties.bridge.bridgeWidth,
                        suffix: 'm',
                    }, {
                        label: t('bridgePropertiesPanel.height'),
                        value: properties.bridge.bridgeHeight,
                        suffix: 'm',
                    }]}></InfoList>
                </div>
            </TabsContent>
            <TabsContent value="construction" className="mt-4">
                <div className="flex min-w-0 flex-col gap-3">
                    <h3 className="text-lg font-bold leading-tight">{t('bridgePropertiesPanel.structure')}</h3>
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.structureName'),
                        value: properties.bridge.structureName,
                    }, {
                        label: t('bridgePropertiesPanel.structureNumber'),
                        value: properties.bridge.structureNumber,
                    }]}></InfoList>
                    <h3 className="mt-2 text-lg font-bold leading-tight">{t('bridgePropertiesPanel.construction')}</h3>
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.partialStructureType'),
                        value: properties.bridge.partialStructureType,
                    }]}></InfoList>
                    <h3 className="mt-2 text-lg font-bold leading-tight">{t('bridgePropertiesPanel.material')}</h3>
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.constructionYear'),
                        value: properties.bridge.constructionYear,
                    }, {
                        label: t('bridgePropertiesPanel.bridgeMaterial'),
                        value: properties.bridge.bridgeMaterial,
                    }, {
                        label: t('bridgePropertiesPanel.materialClass'),
                        value: properties.bridge.materialClass,
                    }, {
                        label: t('bridgePropertiesPanel.materialSubStructure'),
                        value: properties.bridge.materialSubStructure,
                    }
                    ]}></InfoList>
                </div>
            </TabsContent>
            <TabsContent value="traffic" className="mt-4">
                <div className="flex min-w-0 flex-col gap-3">
                    <h3 className="text-lg font-bold leading-tight">{t('bridgePropertiesPanel.load')}</h3>
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.loadCapacityIndex'),
                        value: properties.bridge.loadCapacityIndex,
                    }, {
                        label: t('bridgePropertiesPanel.loadPositionOne'),
                        value: properties.bridge.loadPositionOne,
                    }, {
                        label: t('bridgePropertiesPanel.loadPositionTwo'),
                        value: properties.bridge.loadPositionTwo,
                    }]}></InfoList>
                    <h3 className="mt-2 text-lg font-bold leading-tight">{t('bridgePropertiesPanel.usage')}</h3>
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.trafficAreaUsageDensity'),
                        value: properties.bridge.trafficAreaUsageDensity,
                    }, {
                        label: t('bridgePropertiesPanel.trafficHeavyVehicles'),
                        value: properties.bridge.trafficHeavyVehicles,
                    }, {
                        label: t('bridgePropertiesPanel.trafficVehicles'),
                        value: properties.bridge.trafficVehicles,
                    }, {
                        label: t('bridgePropertiesPanel.urbanArea'),
                        value: properties.bridge.urbanArea,
                    }, {
                        label: t('bridgePropertiesPanel.heavyTrafficBlock'),
                        value: properties.bridge.heavyTrafficBlock,
                    }]}></InfoList>
                </div>
            </TabsContent>
            <TabsContent value="management" className="mt-4">
                <div className="flex min-w-0 flex-col gap-3">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.office'),
                        value: properties.bridge.office,
                    }, {
                        label: t('bridgePropertiesPanel.maintenanceOffice'),
                        value: properties.bridge.maintenanceOffice,
                    }]}></InfoList>

                    {properties.bridge.maintenanceOfficeDetails ?
                        <>
                            <h3 className="text-lg font-bold leading-tight">{t('bridgePropertiesPanel.maintenanceOfficeDetails')}</h3>
                            <InfoList list={[{
                                label: t('bridgePropertiesPanel.type'),
                                value: properties.bridge.maintenanceOfficeDetails.type,
                            }, {
                                label: t('bridgePropertiesPanel.name'),
                                value: properties.bridge.maintenanceOfficeDetails.name,
                            }, {
                                label: t('bridgePropertiesPanel.state'),
                                value: properties.bridge.maintenanceOfficeDetails.state,
                            }, {
                                label: t('bridgePropertiesPanel.street'),
                                value: properties.bridge.maintenanceOfficeDetails.street,
                            }, {
                                label: t('bridgePropertiesPanel.postalCode'),
                                value: properties.bridge.maintenanceOfficeDetails.postalCode,
                            }, {
                                label: t('bridgePropertiesPanel.location'),
                                value: properties.bridge.maintenanceOfficeDetails.location,
                            }, {
                                label: t('bridgePropertiesPanel.phone'),
                                value: properties.bridge.maintenanceOfficeDetails.phone,
                            }, {
                                label: t('bridgePropertiesPanel.person'),
                                value: properties.bridge.maintenanceOfficeDetails.person,
                            }, {
                                label: t('bridgePropertiesPanel.branch'),
                                value: properties.bridge.maintenanceOfficeDetails.branch,
                            }, {
                                label: t('bridgePropertiesPanel.subsidiary'),
                                value: properties.bridge.maintenanceOfficeDetails.subsidiary,
                            }]}></InfoList>
                        </>
                        :
                        <></>}
                </div>
            </TabsContent>
            <TabsContent value="risk" className="mt-4">
                <div className="flex min-w-0 flex-col gap-3">
                    <InfoList list={[{
                        label: t('bridgePropertiesPanel.ageClass'),
                        value: properties.bridge.ageClass,
                    }, {
                        label: t('bridgePropertiesPanel.conditionGradeClass'),
                        value: properties.bridge.conditionGradeClass,
                    }, {
                        label: t('bridgePropertiesPanel.conditionGradeEvaluation'),
                        value: properties.bridge.conditionGradeEvaluation,
                        color: getConditionColor(properties.bridge.conditionGradeEvaluation),
                    }]}></InfoList>
                    {properties.bridge.partOfBastList === 'NEIN' ?
                        <p className="text-sm">{t('bridgePropertiesPanel.notPartOfBastList')} <a className="underline underline-offset-2 hover:no-underline" href={t('bridgePropertiesPanel.bastListLink')} target="_blank" rel="noreferrer">BASt-Liste</a></p>
                        :
                        <p className="text-sm">{t('bridgePropertiesPanel.partOfBastList')} <a className="underline underline-offset-2 hover:no-underline" href={t('bridgePropertiesPanel.bastListLink')} target="_blank" rel="noreferrer">BASt-Liste</a></p>
                    }
                </div>
            </TabsContent>
            <TabsContent value="projects" className="mt-4">
                <div className="flex min-w-0 flex-col gap-3">
                    <h3 className="text-lg font-bold leading-tight">{t('bridgePropertiesPanel.projects')}</h3>
                    {!properties.bridge.projects || properties.bridge.projects.length === 0 ?
                        <p className="text-sm text-muted-foreground">{t('bridgePropertiesPanel.noProjects')}</p>
                        :
                        <ol className="flex flex-col gap-1 text-sm">
                            {properties.bridge.projects.map((project: any, index: number) => {
                                return <li key={index} className="min-w-0 break-words">
                                    <a className="underline underline-offset-2 hover:no-underline" href={project.link} target="_blank" rel="noreferrer">{project.project} {project.status}</a>
                                </li>
                            })}
                        </ol>
                    }
                    {properties.bridge.germanRailwaysData ?
                        <div className="flex min-w-0 flex-col gap-3">
                            <img className="max-w-full" width={100} src={'/logos/deutsche-bahn.png'} alt={t('bridgePropertiesPanel.deutscheBahnAlt')} />
                            <h4 className="text-base font-bold leading-tight">{t('bridgePropertiesPanel.germanRailwaysData')}</h4>
                            <InfoList list={[{
                                label: t('bridgePropertiesPanel.description'),
                                value: properties.bridge.germanRailwaysData.description,
                            }, {
                                label: t('bridgePropertiesPanel.structure'),
                                value: properties.bridge.germanRailwaysData.structure,
                            }, {
                                label: t('bridgePropertiesPanel.area'),
                                value: properties.bridge.germanRailwaysData.area,
                            }, {
                                label: t('bridgePropertiesPanel.businessUnit'),
                                value: properties.bridge.germanRailwaysData.businessUnit,
                            }, {
                                label: t('bridgePropertiesPanel.region'),
                                value: properties.bridge.germanRailwaysData.region,
                            }, {
                                label: t('bridgePropertiesPanel.segment'),
                                value: properties.bridge.germanRailwaysData.segment,
                            }, {
                                label: t('bridgePropertiesPanel.track'),
                                value: properties.bridge.germanRailwaysData.track,
                            }, {
                                label: t('bridgePropertiesPanel.measures'),
                                value: properties.bridge.germanRailwaysData.measures,
                            }]}></InfoList>
                        </div>
                        :
                        <></>}
                </div>
            </TabsContent>
        </Tabs>
    </div>;
}
